import { Navigate, useLocation, useOutlet } from 'react-router';
import { useAuthContext } from 'app/contexts/auth/context';
import { GHOST_ENTRY_PATH, REDIRECT_URL_KEY } from '../constants/app.constant';
import { SplashScreen } from 'components/template/SplashScreen';
import { NoTenantScreen } from 'components/template/NoTenantScreen';

export default function AuthGuard() {
  const outlet = useOutlet();
  const { isAuthenticated, isInitialized, tenantNotAssigned, accessDeniedReason } =
    useAuthContext();
  const location = useLocation();

  // If authentication is still initializing, show the main loader with logo
  if (!isInitialized) {
    return <SplashScreen />;
  }

  // Authenticated but the backend rejected the account (no tenant or no roles
  // in Keycloak) — block the SPA with an explanatory screen.
  if (isAuthenticated && (tenantNotAssigned || accessDeniedReason)) {
    return (
      <NoTenantScreen
        reason={accessDeniedReason || (tenantNotAssigned ? 'no-tenant' : null)}
      />
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={`${GHOST_ENTRY_PATH}?${REDIRECT_URL_KEY}=${location.pathname}`}
        replace
      />
    );
  }

  return <>{outlet}</>;
}
